import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {order} from '../../api/order/order.api';
import {RequestService} from '../../../handlers/request/request.service';
import {Create, GetAll, GetSingle, Rate, ReOrder, Reschedule} from '../../models/order/requests/order';
import { IdCustomerWebSafe } from '../../models/shared/requests/id-customer-web-safe';
import {globalEnv} from '../../connection/global/global.env';
import {EstimatedTimeResponse, GetActiveOrdersBody, GetActiveOrdersResponse, GetPreviousOrdersResponse } from '../../models/order/responses/order-res';
import { UploadImgResponseInterface } from '../../models/legal/responses/legal-res';
import {DeliveryTypeTimeBody, DeliveryTypeTimeResponse} from '../../models/delivery-type-time/delivery-type-time.model';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(private req: RequestService) { }

  create(data: Create, params: IdCustomerWebSafe): Observable<any> {
    return this.req.post(`${globalEnv.be2}${order.create}`, data, params, true);
  }

  getAll(data: GetAll): Observable<any> {
    return this.req.post(`${globalEnv.be2}${order.getOrders}`, data);
  }

  getSingle(params: GetSingle): Observable<any> {
    const url = `${globalEnv.gateway}${order.getOrder}`
      .replace(':orderId', params?.idOrder);
    return this.req.get(url, null, null, false, false);
  }

  getTracking(params: GetSingle): Observable<any> {
    return this.req.get(`${globalEnv.be2}${order.getTracking}`, params);
  }

  getRatings(data): Observable<any> {
    return this.req.get(`${globalEnv.be2}${order.getRatings}`, data);
  }

  rate(data: Rate): Observable<any> {
    return this.req.put(`${globalEnv.be2}${order.rate}`, data, null, null, true);
  }

  reOrder(data: ReOrder, params?): Observable<any> {
    return this.req.post(`${globalEnv.be2}${order.reOrder}`, data, params, true);
  }

  cancelOrder(data, params?): Observable<any> {
    return this.req.post(`${globalEnv.be2}${order.cancelOrder}`, data, params, true);
  }

  updateOrder(data: Reschedule): Observable<any> {
    return this.req.put(`${globalEnv.be2}${order.orderUpdate}`, data, true);
  }

  updateUserPrime( data ): Observable<any> {
    return this.req.put(`${globalEnv.gateway}${order.updateUserPrime}`, data, true);
  }

  getListOrderCancellationReasonCustomer(): Observable<any> {
    return this.req.get(`${globalEnv.gateway}${order.getListOrderCancellationReasonCustomer}`);
  }

  getEstimatedTime(idAddress?: number, orderId?: number): Observable<EstimatedTimeResponse> {

    let url: string = order.getEstimatedTimeByDefault;

    if (idAddress) {
      url = orderId
        ? order.getEstimatedTimeByIdAddressAndOrderId
        : order.getEstimatedTimeByIdAddress;
    }

    const urlFormatted: string = url
      .replace(':idAddress', idAddress?.toString())
      .replace(':orderId', orderId?.toString());

    return this.req.get(`${globalEnv.gateway}${urlFormatted}`, null, null, false, false);
  }

  getActiveOrders(data: GetActiveOrdersBody): Observable<GetActiveOrdersResponse> {
    const params = {
      idCustomerWebSafe: data?.idCustomerWebSafe,
    };
    return this.req.get(`${globalEnv.be2}${order.getActiveOrders}`, params, false, false, false);  
  }

  getPreviousOrders(data: GetActiveOrdersBody): Observable<GetPreviousOrdersResponse> {
    const params:GetActiveOrdersBody = {
      idCustomerWebSafe: data?.idCustomerWebSafe,
    };
    if(data.cursor !== null){
      params.cursor = data.cursor;
    }

    return this.req.get(`${globalEnv.be2}${order.getPreviousOrders}`,  params, false, false, false);
  }

  uploadPrescription( prescriptionData ):Observable<UploadImgResponseInterface>{
    return this.req.post(`${globalEnv.gateway}${order.uploadPrescription}`, prescriptionData, null, true, false);
  }

  getDeliveryTypeTime(body: DeliveryTypeTimeBody): Observable<DeliveryTypeTimeResponse> {
    return this.req.post(`${globalEnv.be2}${order.getDeliveryTypeTime}`, body, null, false, false);
  }
}
